import { render } from "./liabilitiesDialog.vue?vue&type=template&id=652b4a7a"
import script from "./liabilitiesDialog.vue?vue&type=script&lang=js"
export * from "./liabilitiesDialog.vue?vue&type=script&lang=js"

import "./liabilitiesDialog.vue?vue&type=style&index=0&id=652b4a7a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__